import { SlideOutMenuState, SlideoutState } from '@mm/state/interfaces/view';
import { StoreState } from '@mm/state/store-interfaces';
import React, { useLayoutEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import { AddWidgetProps } from '../../../common/components/AddWidgetInsert/AddWidgetInsert';
import { WidgetAdderSlideoutMenu } from '../../../common/components/AddWidgetInsert/WidgetAdderSlideoutMenu/WidgetAdderSlideoutMenu';
import { randomId } from '../../../common/helpers/utils';
import { ActivePageSlideMenu } from '../../../layout/BotBuilderSidebar/ActivePageSlideMenu/ActivePageSlideMenu';
import { AudienceSlideoutMenu } from '../../features/beta/modules/Audiences/AudienceSlideoutMenu/AudienceSlideoutMenu';
import { ContactSlideoutMenu } from '../../features/beta/modules/Audiences/ContactSlideoutMenu/ContactSlideoutMenu';
import { CustomerChatInstallationGuideSlideoutMenu } from '../../features/startBotPromoters/customerChat/CustomerChatEditor/CustomerChatInstallationGuideSlideoutMenu/CustomerChatInstallationGuideSlideoutMenu';
import { BusinessHoursSlideoutEditor } from './menus/BusinessHoursSlideoutEditor/BusinessHoursSlideoutEditor';
import {
  ChatBlasterSlideoutEditor,
  ChatBlasterSlideoutEditorProps,
} from './menus/ChatBlasterSlideoutEditor/ChatBlasterSlideoutEditor';
import {
  ConnectionsSlideoutEditor,
  ConnectionsSlideoutProps,
} from './menus/ConnectionsSlideoutEditor/ConnectionsSlideoutEditor';
import {
  CTMAdSlideoutEditor,
  CTMAdsSlideoutEditorProps,
} from './menus/CTMAdSlideoutEditor/CTMAdSlideoutEditor';
import { CustomerChatWidgetSlideoutEditor } from './menus/CustomerChatWidgetSlideoutEditor/CustomerChatWidgetSlideoutEditor';

import {
  EditJSONWebhookIntegrationSlideoutEditor,
  EditJSONWebhookIntegrationSlideoutEditorProps,
} from './menus/EditJSONWebhookIntegrationSlideoutEditor/EditJSONWebhookIntegrationSlideoutEditor';
import {
  EngagementSlideoutEditor,
  EngagementsSlideoutEditorProps,
} from './menus/EngagementSlideoutEditor/EngagementSlideoutEditor';
import { FBCommentGuardSlideoutEditor } from './menus/FBCommentGuardSlideoutEditor/FBCommentGuardSlideoutEditor';
import { FBWelcomerSlideoutEditor } from './menus/FBWelcomerSlideoutEditor/FBWelcomerSlideoutEditor';
import {
  GetemailsSlideoutEditorNew,
  GetemailsSlideoutEditorNewProps,
  GetemailsSlideoutEditorNewSettings,
} from './menus/GetemailsSlideoutEditorNew/GetemailsSlideoutEditorNew';
import {
  GetemailsSlideoutEditor,
  GetemailsSlideoutEditorProps,
} from './menus/GetemailsSlideoutEditor/GetemailsSlideoutEditor';
import {
  GoogleSheetsIntegrationSlideoutEditor,
  GoogleSheetsIntegrationSlideoutEditorProps,
} from './menus/GoogleSheetIntegrationSlideoutEditor/GoogleSheetsIntegrationSlideoutEditor';
import {
  SlackNotificationSlideoutEditor,
  SlackNotificationSlideoutEditorProps,
} from './menus/SlackNotificationSlideoutEditor/SlackNotificationSlideoutEditor';
import { IGCommentGuardSlideoutEditor } from './menus/IGCommentGuardSlideoutEditor/IGCommentGuardSlideoutEditor';
import { IGLiveSlideoutEditor } from './menus/IGLiveSlideoutEditor/IGLiveSlideoutEditor';
import { IGStoryMentionSlideoutEditor } from './menus/IGStoryMentionSlideoutEditor/IGStoryMentionSlideoutEditor';
import { IGStoryReactionSlideoutEditor } from './menus/IGStoryReactionSlideoutEditor/IGStoryReactionSlideoutEditor';
import { IGWelcomerSlideoutEditor } from './menus/IGWelcomerSlideoutEditor/IGWelcomerSlideoutEditor';
import {
  MailchimpIntegrationSlideoutEditor,
  MailchimpIntegrationSlideoutEditorProps,
} from './menus/MailchimpIntegrationSlideoutEditor/MailchimpIntegrationSlideoutEditor';
import { QASlideoutEditor } from './menus/QASlideoutEditor/QASlideoutEditor';
import {
  ShareLinksSlideoutEditor,
  ShareLinksSlideoutEditorProps,
} from './menus/ShareLinksSlideoutEditor/ShareLinksSlideoutEditor';
import {
  ISlideoutAutomationAction,
  SlideoutAutomationAction,
} from './menus/SlideoutAutomationAction/SlideoutAutomationAction';
import { SlideoutBusinessForm } from './menus/SlideoutBusinessForm/SlideoutBusinessForm';
import {
  ISlideoutDateTime,
  SlideoutDateTime,
} from './menus/SlideoutDateTime/SlideoutDateTime';
import { SlideoutDialogueEditor } from './menus/SlideoutDialogueEditor/SlideoutDialogueEditor';
import { SlideoutEmail } from './menus/SlideoutEmail/SlideoutEmail';
import { SlideoutJSONWebhooks } from './menus/SlideoutJSONWebhooks/SlideoutJSONWebhooks';
import { SlideoutMenuAttributessAndTags } from './menus/SlideoutMenuAttributessAndTags/SlideoutMenuAttributessAndTags';
import { SlideoutWhatsNew } from './menus/SlideoutWhatsNew/SlideoutWhatsNew';
import { SMSKeywordSlideoutEditor } from './menus/SMSKeywordSlideoutEditor/SMSKeywordSlideoutEditor';
import {
  UploadContactListSlideoutEditor,
  UploadContactListSlideoutEditorProps,
} from './menus/UploadContactListSlideoutEditor/UploadContactListSlideoutEditor';
import {
  ZapierIntegrationSlideoutEditor,
  ZapierIntegrationSlideoutProps,
} from './menus/ZappierIntegrationSlideoutEditor/ZapierIntegrationSlideoutEditor';
import {
  AutomationEmailSmsSettingsSlideout,
  IAutomationEmailSmsSettingsSlideout,
} from './menus/AutomationEmailSmsSettingsSlideout/AutomationEmailSmsSettingsSlideout';
import { SlideoutEmailStats } from './menus/SlideoutEmailStats/SlideoutEmailStats';
import { AutomationSoLDSettingsSlideout } from './menus/AutomationSoLDSettingsSlideout/AutomationSoLDSettingsSlideout';
import {
  AutomationEmailGenerateSlideout,
  IAutomationEmailGenerateSlideout,
} from './menus/AutomationEmailGenerateSlideout/AutomationEmailGenerateSlideout';
import {
  AutomationSoLDSlackNotificationSettings,
  IAutomationSoLDSlackNotificationSettings,
} from './menus/AutomationSoLDSlackNotificationSettings/AutomationSoLDSlackNotificationSettings';
import {
  AutomationSoLDSMSNotificationSettings,
  IAutomationSoLDSMSNotificationSettings,
} from './menus/AutomationSoLDSMSNotificationSettings/AutomationSoLDSMSNotificationSettings';
import {
  AutomationSoLDEmailNotificationSettings,
  IAutomationSoLDEmailNotificationSettings,
} from './menus/AutomationSoLDEmailNotificationSettings/AutomationSoLDEmailNotificationSettings';
import {
  SlideoutSelectAutomationAudience,
  SlideoutSelectAutomationAudienceProps,
} from './menus/SlideoutSelectAutomationAudience/SlideoutSelectAutomationAudience';
import {
  AutomationHotLeadAutomation,
  IAutomationHotLeadAutomation,
} from './menus/AutomationHotLeadAutomation/AutomationHotLeadAutomation';
import {
  AutomationSalesTeamNotifications,
  IAutomationSalesTeamNotifications,
} from './menus/AutomationSalesTeamNotifications/AutomationSalesTeamNotifications';
import { AutomationReportingSlideout } from './menus/AutomationReportingSlideout/AutomationReportingSlideout';
import {
  FacebookAdsIntegrationEditorSlideout,
  FacebookAdsIntegrationEditorSlideoutProps,
} from './menus/FacebookAdsIntegrationEditorSlideout/FacebookAdsIntegrationEditorSlideout';
import {
  SlideoutTagWidgetEditor,
  TagWidgetEditorProps,
} from './menus/SlideoutTagWidgetEditor/SlideoutTagWidgetEdtor';
import {
  EditWebhookSuppressionListSlideoutEditor,
  EditWebhookSuppressionListSlideoutEditorProps,
} from './menus/EditWebhookSuppressionListSlideoutEditor/EditWebhookSuppressionListSlideoutEditor';
import {
  MyLeadsFiltersSlideout,
  MyLeadsFiltersSlideoutProps,
} from './menus/MyLeadsFiltersSlideout/MyLeadsFiltersSlideout';
import {
  ContactUsSlideoutMenu,
  ContactUsSlideoutMenuProps,
} from './menus/ContactUsSlideoutMenu/ContactUsSlideoutMenu';
import {
  GoogleAdsIntegrationEditorSlideout,
  GoogleAdsIntegrationEditorSlideoutProps,
} from './menus/GoogleAdsIntegrationEditorSlideout/GoogleAdsIntegrationEditorSlideout';
import {
  SendingDomainFromNameSlideout,
  SendingDomainFromNameSlideoutProps,
} from './menus/SendingDomainFromNameSlideout/SendingDomainFromNameSlideout';
import {
  DataQualityTestSlideout,
  DataQualityTestSlideoutProps,
} from './menus/DataQualityTestSlideout/DataQualityTestSlideout';

type PromoterSlideoutEditorProps = {
  promoterId: number;
};

const SLIDEOUT_OPEN_BODY_CLASS = 'body--slideout-open';

// tslint:disable-next-line:cyclomatic-complexity
const SlideoutMenu = ({ show, menuType, menuProps }: SlideoutState) => {
  useLayoutEffect(() => {
    let originalScrollPosition = document.documentElement.scrollTop || 0;
    document.body.classList.add(SLIDEOUT_OPEN_BODY_CLASS);
    return () => {
      document.body.classList.remove(SLIDEOUT_OPEN_BODY_CLASS);
      document.documentElement.scrollTop = originalScrollPosition;
      originalScrollPosition = 0;
    };
  }, []);
  if (!show) return null;
  switch (menuType) {
    case 'editor':
      return <SlideoutDialogueEditor {...menuProps} />;
    case 'attributesAndTags':
      return <SlideoutMenuAttributessAndTags {...menuProps} />;
    case 'tagWidgetEditor':
      return (
        <SlideoutTagWidgetEditor {...(menuProps as TagWidgetEditorProps)} />
      );
    case 'whatsNew':
      return <SlideoutWhatsNew {...menuProps} />;
    case 'newAudience':
      return <AudienceSlideoutMenu {...menuProps} newAudience />;
    case 'editAudience':
      return <AudienceSlideoutMenu {...menuProps} />;
    case 'contact':
      return <ContactSlideoutMenu {...menuProps} />;
    case 'pages':
      return <ActivePageSlideMenu {...menuProps} />;
    case 'businessForm':
      return <SlideoutBusinessForm {...menuProps} />;
    case 'contactUsForm':
      return (
        <ContactUsSlideoutMenu
          {...(menuProps as ContactUsSlideoutMenuProps)}
          menuType={menuType}
        />
      );
    case 'widgetAdder':
      return <WidgetAdderSlideoutMenu {...(menuProps as AddWidgetProps)} />;
    case 'dateTime':
      return <SlideoutDateTime {...(menuProps as ISlideoutDateTime)} />;
    case 'automationAction':
      return (
        <SlideoutAutomationAction
          {...(menuProps as ISlideoutAutomationAction)}
        />
      );
    case 'customerChatSlideoutEditor':
      return (
        <CustomerChatWidgetSlideoutEditor
          {...(menuProps as PromoterSlideoutEditorProps)}
        />
      );
    case 'getemailsEditor':
      return (
        <GetemailsSlideoutEditor
          {...(menuProps as GetemailsSlideoutEditorProps)}
        />
      );
    case 'getemailsEditorNew':
      return <GetemailsSlideoutEditorNew {...(menuProps as any)} />;
    case 'getEmailsEditorNewSettings':
      return (
        <GetemailsSlideoutEditorNewSettings
          {...(menuProps as GetemailsSlideoutEditorNewProps)}
        />
      );
    case 'customerChatInstallationGuide':
      return (
        <CustomerChatInstallationGuideSlideoutMenu {...(menuProps as any)} />
      );
    case 'createEditJSONWebhook':
      return <SlideoutJSONWebhooks {...menuProps} />;
    case 'qaEditor':
      return <QASlideoutEditor {...menuProps} />;
    case 'engagementEditor':
      return (
        <EngagementSlideoutEditor
          {...(menuProps as EngagementsSlideoutEditorProps)}
        />
      );
    case 'uploadContactListEditor':
      return (
        <UploadContactListSlideoutEditor
          {...(menuProps as UploadContactListSlideoutEditorProps)}
        />
      );
    case 'automationSelectAudience':
      return (
        <SlideoutSelectAutomationAudience
          {...(menuProps as SlideoutSelectAutomationAudienceProps)}
        />
      );
    case 'smsBlasterEditor':
      return (
        <ChatBlasterSlideoutEditor
          {...(menuProps as ChatBlasterSlideoutEditorProps)}
        />
      );
    case 'smsKeywordEditor':
      return <SMSKeywordSlideoutEditor {...menuProps} />;
    case 'fbWelcomerEditor':
      return <FBWelcomerSlideoutEditor {...menuProps} />;
    case 'fbCommentGuardEditor':
      return (
        <FBCommentGuardSlideoutEditor
          {...(menuProps as PromoterSlideoutEditorProps)}
        />
      );
    case 'shareLinksEditor':
      return (
        <ShareLinksSlideoutEditor
          {...(menuProps as ShareLinksSlideoutEditorProps)}
        />
      );
    case 'igWelcomerEditor':
      return <IGWelcomerSlideoutEditor {...menuProps} />;
    case 'igCommentGuardEditor':
      return (
        <IGCommentGuardSlideoutEditor
          {...(menuProps as PromoterSlideoutEditorProps)}
        />
      );
    case 'igStoryMentionEditor':
      return (
        <IGStoryMentionSlideoutEditor
          {...(menuProps as PromoterSlideoutEditorProps)}
        />
      );
    case 'igStoryReactionEditor':
      return (
        <IGStoryReactionSlideoutEditor
          {...(menuProps as PromoterSlideoutEditorProps)}
        />
      );
    case 'igLiveEditor':
      return (
        <IGLiveSlideoutEditor {...(menuProps as PromoterSlideoutEditorProps)} />
      );
    case 'zapierIntegrationEditor':
      return (
        <ZapierIntegrationSlideoutEditor
          {...(menuProps as ZapierIntegrationSlideoutProps)}
        />
      );
    case 'connectionsEditor':
      return (
        <ConnectionsSlideoutEditor
          {...(menuProps as ConnectionsSlideoutProps)}
        />
      );
    case 'fbAdsIntegrationEditor':
      return (
        <FacebookAdsIntegrationEditorSlideout
          {...(menuProps as FacebookAdsIntegrationEditorSlideoutProps)}
        />
      );
    case 'googleAdsIntegrationEditor':
      return (
        <GoogleAdsIntegrationEditorSlideout
          {...(menuProps as GoogleAdsIntegrationEditorSlideoutProps)}
        />
      );
    case 'editJSONWebhookIntegrationEditor':
      return (
        <EditJSONWebhookIntegrationSlideoutEditor
          {...(menuProps as EditJSONWebhookIntegrationSlideoutEditorProps)}
        />
      );
    case 'editWebhoookSuppressionListEditor':
      return (
        <EditWebhookSuppressionListSlideoutEditor
          {...(menuProps as EditWebhookSuppressionListSlideoutEditorProps)}
        />
      );
    case 'mailchimpIntegrationEditor':
      return (
        <MailchimpIntegrationSlideoutEditor
          {...(menuProps as MailchimpIntegrationSlideoutEditorProps)}
        />
      );
    case 'googleSheetIntegrationEditor':
      return (
        <GoogleSheetsIntegrationSlideoutEditor
          {...(menuProps as GoogleSheetsIntegrationSlideoutEditorProps)}
        />
      );
    case 'slackIntegrationEditor':
      return (
        <SlackNotificationSlideoutEditor
          {...(menuProps as SlackNotificationSlideoutEditorProps)}
        />
      );
    case 'businessHours':
      return <BusinessHoursSlideoutEditor {...menuProps} />;
    case 'email':
      return <SlideoutEmail {...menuProps} />;
    case 'emailStats':
      return <SlideoutEmailStats {...menuProps} />;
    case 'ctmAdsEditor':
      return (
        <CTMAdSlideoutEditor {...(menuProps as CTMAdsSlideoutEditorProps)} />
      );

    case 'automationEmailSmsSettings':
      return (
        <AutomationEmailSmsSettingsSlideout
          {...(menuProps as IAutomationEmailSmsSettingsSlideout)}
        />
      );
    case 'automationSoLDSettings':
      return (
        <AutomationSoLDSettingsSlideout
          {...(menuProps as IAutomationEmailSmsSettingsSlideout)}
          menuType={menuType}
        />
      );
    case 'automationEmailGenerate':
      return (
        <AutomationEmailGenerateSlideout
          {...(menuProps as IAutomationEmailGenerateSlideout)}
          menuType={menuType}
        />
      );
    case 'automationSoLDSmsNotificationSettings':
      return (
        <AutomationSoLDSMSNotificationSettings
          {...(menuProps as IAutomationSoLDSMSNotificationSettings)}
          menuType={menuType}
        />
      );
    case 'automationSoLDSlackNotificationSettings':
      return (
        <AutomationSoLDSlackNotificationSettings
          {...(menuProps as IAutomationSoLDSlackNotificationSettings)}
          menuType={menuType}
        />
      );
    case 'automationSoLDEmailNotificationSettings':
      return (
        <AutomationSoLDEmailNotificationSettings
          {...(menuProps as IAutomationSoLDEmailNotificationSettings)}
          menuType={menuType}
        />
      );
    case 'automationSalesTeamNotifications':
      return (
        <AutomationSalesTeamNotifications
          {...(menuProps as IAutomationSalesTeamNotifications)}
          menuType={menuType}
        />
      );
    case 'automationHotLeadAutomation':
      return (
        <AutomationHotLeadAutomation
          {...(menuProps as IAutomationHotLeadAutomation)}
          menuType={menuType}
        />
      );
    case 'automationReporting':
      return (
        <AutomationReportingSlideout
          {...(menuProps as IAutomationHotLeadAutomation)}
          menuType={menuType}
        />
      );
    case 'myLeadsFilters':
      return (
        <MyLeadsFiltersSlideout
          {...(menuProps as MyLeadsFiltersSlideoutProps)}
        />
      );
    case 'addSendingDomainFromName':
      return (
        <SendingDomainFromNameSlideout
          {...(menuProps as SendingDomainFromNameSlideoutProps)}
        />
      );
    case 'dataQualityTest':
      return (
        <DataQualityTestSlideout
          {...(menuProps as DataQualityTestSlideoutProps)}
        />
      );
    default:
      return null;
  }
};

export default () => {
  const slideouts = useSelector<StoreState, SlideOutMenuState>(
    state => state.view.slideoutMenu,
  );

  const emptySlideoutId = useMemo(() => randomId(), []);

  const anyIsOpen = useMemo(() => slideouts.some(s => s.show), [slideouts]);

  return (
    <>
      <CSSTransitionGroup
        transitionName={{
          enter: 'slideout-menu__enter',
          enterActive: 'slideout-menu__enter-active',
          leave: 'slideout-menu__leave',
          leaveActive: 'slideout-menu__leave-active',
        }}
        transitionEnterTimeout={600}
        transitionLeaveTimeout={600}
      >
        {slideouts.map(
          ({ show, menuType, menuProps }) =>
            show && (
              <SlideoutMenu
                key={menuType || emptySlideoutId}
                show={show}
                menuType={menuType}
                menuProps={menuProps}
              />
            ),
        )}
      </CSSTransitionGroup>
      {anyIsOpen && <div className="main-area__overlay js-overlay" />}
    </>
  );
};
